import { WidgetSearch } from "./WidgetSearch";

export class DispatchRefTrackSearch
{
    customerIds: string[];
    divisionIds: string[];
    regionIds: string[];
    onCallRegionIds: string[];
    classIds: string[];
    statusIds: string[];
    accountManagerIds: string[];
    accountClassType: any;
    contractAdminIds: string[];

    // for v1 backward compatibility
    srvConstInt: any;
    out_S: string;
    customSearch: boolean = false;
    emptySearch: boolean = false;

    constructor(search: WidgetSearch){
        this.customerIds = search.customerIds;
        this.divisionIds = search.divisionIds;
        this.regionIds = search.regionIds;
        this.onCallRegionIds = search.onCallRegions;
        this.classIds = search.classIds;
        this.statusIds = search.statusIds;
        this.accountManagerIds = search.acctMgrIds;        
        this.accountClassType = search.srvConstInt;
        this.contractAdminIds = search.contractAdminIds;
    }
}